import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TrashRegular from './trash-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TrashRegular {...validProps} />;
}
SvgComponent.iconName = 'trashRegular';

export const TrashRegularIcon = svgIconWrapper(SvgComponent);
